function waitForPolyfill(polyfillName, callback) {
  window.polyfillWaitlist = window.polyfillWaitlist || {};
  window.polyfillWaitlist[polyfillName] = window.polyfillWaitlist[polyfillName] || [];
  window.polyfillWaitlist[polyfillName].push(callback);
}

function processPolyfillWaitlist(polyfillName) {
  if(typeof window.polyfillWaitlist !== undefined && typeof window.polyfillWaitlist[polyfillName] !== undefined) {
    window.polyfillWaitlist[polyfillName].forEach(fn => fn());
  }
}

export {waitForPolyfill, processPolyfillWaitlist};
